<template>
  <section class="app-main">
    <transition name="fade" mode="out-in">
      <!-- <router-view :key="key"></router-view> -->
      <router-view @displayNameChange="handleDisplayNameChange"></router-view>
    </transition>
  </section>
</template>

<script>
export default {
  name: 'AppMain',
  computed: {
    // key() {
    //   return this.$route.name !== undefined ? this.$route.name + +new Date() : this.$route + +new Date()
    // }
  },
  methods: {
    handleDisplayNameChange(val) {
      this.$emit('displayNameChange', val)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/layout/components/AppMain.vue